import { AccountClassification, AccountWithExtraInfo, Currency } from '@orbis-systems/orbis-api-middleware';

export const HIGHLIGHTED_ACCOUNTS = [
    AccountClassification.DVP,
    AccountClassification.DayTrader,
    AccountClassification.Margin,
];

export const shouldHighlightRow = (
    allocationValue: number,
    cashOnAccount: number,
    accountClassification: AccountClassification,
): boolean => {
    return HIGHLIGHTED_ACCOUNTS.includes(accountClassification) && allocationValue > cashOnAccount;
};

export const convertAccountsToBaseCurrency = <T extends AccountWithExtraInfo>(
    accounts: T[],
    fxRate: number,
    baseCurrency: string = Currency.UsDollar,
): T[] => {
    return accounts.map((account) => ({
        ...account,
        baseCurrency,
        balance: (account.balance ?? 0) * fxRate,
        cashOnAccount: (account.cashOnAccount ?? 0) * fxRate,
        markToMarket: (account.markToMarket ?? 0) * fxRate,
        sodCashBalance: (account.sodCashBalance ?? 0) * fxRate,
        sodMarginBalance: (account.sodMarginBalance ?? 0) * fxRate,
        sodShortBalance: (account.sodShortBalance ?? 0) * fxRate,
        totalDividendAmount: (account.totalDividendAmount ?? 0) * fxRate,
        currency: baseCurrency || Currency.UsDollar,
    }));
};
